//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../no/Builder.js";
import "../Features/Features.SelectFlatPattern.js";
import "../no/SelectObject.js";
let d=[[[0,"AddedBottom",1,0],[0,"AddedTop",1,0],[0,"BendDown",1,0],[0,"BendTangent",1,0],[0,"BendUp",1,0],[0,"DeviationalTolerance",1,0],[0,"DxfRevision",1,0],[0,"ExportLocation",1,0],[1,"FlatPattern",0,"Features.SelectFlatPattern",0],[0,"InnerMold",1,0],[0,"InteriorCutout",1,0],[0,"InteriorFeature",1,0],[0,"OuterMold",1,0],[0,"OutputFile",1,0],[0,"Type",1,0]],[],[]];
SPLM.Features.SheetMetal.ExportFlatPatternBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.ExportFlatPatternBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.ExportFlatPatternBuilder.FileType = Object.freeze({
    "Dxf" : "Dxf", "TrumpfGeo" : "TrumpfGeo"});

SPLM.Features.SheetMetal.ExportFlatPatternBuilder.DxfRevisionType = Object.freeze({
    "R12" : "R12", "R13" : "R13", "R14" : "R14", "R2000" : "R2000", "R2004" : "R2004", "R2005" : "R2005", "R2007" : "R2007", "R20102012" : "R20102012", "R20132016" : "R20132016", "R2018" : "R2018"});

SPLM.Features.SheetMetal.ExportFlatPatternBuilder.ExportLocationOptions = Object.freeze({
    "Teamcenter" : "Teamcenter", "Native" : "Native"});

export default SPLM;